import { render, staticRenderFns } from "./ExercisesView.vue?vue&type=template&id=0695c9ad&scoped=true&"
import script from "./ExercisesView.vue?vue&type=script&lang=js&"
export * from "./ExercisesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0695c9ad",
  null
  
)

export default component.exports